import { IonCard, IonCardContent, IonCardHeader } from '@ionic/react'
import strings from 'mobile_web/strings'
import { FC } from 'react'
import Button from '../../common/components/Button'
import Modal from '../../common/components/modal'

interface Props {
	onCloseSuccessModal: () => void
}

const SuccessModal: FC<Props> = ({ onCloseSuccessModal }) => {
	return (
		<Modal isOpen={true} backdropDismiss={false} cssClass="success-modal">
			<IonCard>
				<IonCardHeader>
					<Button className="close" onClick={onCloseSuccessModal} ariaLabel={strings.close}>
						<i className="fal fa-xmark" />
					</Button>
				</IonCardHeader>
				<IonCardContent className="success-modal-content">
					<h1>{strings.purchase_successful}</h1>
					<p>{strings.purchase_successful_description}</p>

					<Button fill="clear" ariaLabel={strings.pay_now} className="-submit" onClick={onCloseSuccessModal}>	
						<p>{strings.purchase_successful_continue}</p>
					</Button>
				</IonCardContent>
			</IonCard>
		</Modal>
	)
}

export default SuccessModal
